export const CREATE_SESSION = 'CREATE_SESSION'

export const RESET_PHONE_UPDATE = 'RESET_PHONE_UPDATE'

export const SET_PROFILE_DATA = 'SET_PROFILE_DATA'

export const SET_DISCOUNTS = 'SET_DISCOUNTS'
